/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SimplifiedEntity } from '../../models/simplified-entity';

export interface ApiTapioGetAllCardByEntityPaged2Get$Json$Params {
  CLIENT_ID?: string;
  page_no?: number;
  page_size?: number;
  Authorization?: string;
}

export function apiTapioGetAllCardByEntityPaged2Get$Json(http: HttpClient, rootUrl: string, params?: ApiTapioGetAllCardByEntityPaged2Get$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {
  const rb = new RequestBuilder(rootUrl, apiTapioGetAllCardByEntityPaged2Get$Json.PATH, 'get');
  if (params) {
    rb.query('CLIENT_ID', params.CLIENT_ID, {});
    rb.query('page_no', params.page_no, {});
    rb.query('page_size', params.page_size, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SimplifiedEntity>>;
    })
  );
}

apiTapioGetAllCardByEntityPaged2Get$Json.PATH = '/api/Tapio/GetAllCardByEntityPaged2';
